// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class LayoutController {
   data: any
   scope: any
   constructor(scope: any, data: any) {
      this.scope = scope
      this.data = data
      this.scope.layout = {
         virgin: true,
         modal: false
      }

      // modal dialogs
      const modals = ['saveditems.visible', 'search.advanced','docDetail.visible']
      this.scope.$watch(modals.join(' || '), (visible: any) => {
         return this.scope.layout.modal = visible
      })

      // virgin state
      this.scope.$watch('feed.items.length', (length: any) => {
         if (!this.scope.layout.virgin) { return }
         if (length > 0) { return this.scope.layout.virgin = false }
      })
   }
}


LayoutController.$inject = ["$scope", "dataService"]

angular.module('summonApp.controllers')
   .controller('LayoutCtrl', LayoutController)
